import React, { useState } from "react";
// api services
import apiJurados from "../api/Jurados/api-jurados";

export const useGestionarJurados = () => {
  const [jurados, setJurados] = useState<any>([]);
  const [jurado, setJurado] = useState<any>(initialValuesJurado);

  const consultarJurados = async () => {
    let data = await apiJurados.getJurados();
    return setJurados(data);
  };

  const consultarJuradoNumeroDocumento = async (numero_documento: number) => {
    let data = await apiJurados.obetenerJuradoDocumento(numero_documento);
    return setJurado(data);
  }

  const consultarJurado = async (id_jurado: any) => {
    let data = await apiJurados.obetenerJuradoId(id_jurado);
    
    return setJurado(data);
  };
  return { jurados, consultarJurados, consultarJuradoNumeroDocumento, jurado, consultarJurado, setJurado };
};

// initial values
const initialValuesJurado = {
  areas_conocimientos: [],
  barrio: "",
  comuna_residencia: "",
  correo_electronico: "",
  departamento_residencia: "",
  direccion: "",
  educacion_formal: [],
  educacion_no_formal: [],
  estrato: "",
  experiencias: [],
  experiencias_profesionales: [],
  fecha_creacion: "",
  fecha_modificacion: "",
  fecha_nacimiento: "",
  id_jurado: 0,
  identidad_genero: 0,
  municipio_residencia: "",
  numero_documento: "",
  orientacion_sexual: 0,
  pais_nacimiento: "",
  path_documento: "",
  documentos: [],
  path_foto: "",
  perfil: "",
  primer_apellido: "",
  primer_nombre: "",
  publicaciones: [],
  reconocimientos: [],
  segundo_apellido: "",
  segundo_nombre: "",
  sexo: "",
  telefono_celular: "",
  telefono_fijo: "",
  tipo_identificacion: "",
  usuario_creacion: "",
  usuario_modificacion: "",
};
